<template>
  <SubBundlesBody/>
</template>

<script>
// @ is an alias to /src
import SubBundlesBody from '@/components/SubBundlesBody.vue'

export default {
  name: 'SubBundlesView',
  components: {
    SubBundlesBody
  }
}
</script>
